import { useAppExtensionState } from './useAppExtensionState'
import type {
  AppExtensionContext,
  AppExtensionController,
  AppExtensionDefinition,
  AppExtensionMatchInput
} from './types'

import { upsellExtension } from './upsell'

// Register a new app's extension here — AppIntegrationDetailView and the manage page pick it up automatically, no changes needed on either.
export const APP_EXTENSIONS: AppExtensionDefinition[] = [upsellExtension]

export const findAppExtension = (input: AppExtensionMatchInput): AppExtensionDefinition | undefined => {
  return APP_EXTENSIONS.find(ext => ext.matches(input))
}

/**
 * Finds the extension matching the current app and builds its controller.
 * Only the matching extension's `build()` ever runs — no other extension's logic executes.
 */
export const useActiveAppExtension = (
  input: AppExtensionMatchInput,
  ctx: AppExtensionContext
): AppExtensionController | null => {
  const ui = useAppExtensionState()
  const extension = findAppExtension(input)
  return extension ? extension.build(ctx, ui) : null
}
